import {GetWatermarkDetailResponseBody} from '@dms/api/sales';

import {WatermarkFormType} from '../types/WatermarkFormType';

export const getDefaultValue = (
  data?: GetWatermarkDetailResponseBody
): Partial<WatermarkFormType> => ({
  name: data?.name ?? '',
  size: data?.size ?? 100,
  position: data?.position ?? 'center_center',
  fitToImage: data?.fitToImage ?? false,
  usageType: data?.usageType ?? 'ALL_PHOTOS',
  composition: data?.composition ?? null,
  fileId:
    data?.fileId && data?.imageUri
      ? {
          id: data.fileId,
          url: data.imageUri,
        }
      : undefined,
});
